<script setup lang="ts">

const {
  course,
  toggleCourseBookmark,
} = useCourseState();

const { dispatchMessage } = useSystemMessages();
const { courseBookmarked } = useTrackingCourse();

const toggleBookmarkCourse = async () => {
  await toggleCourseBookmark();

  if (!course.value) {
    return;
  }

  if (course.value.bookmarked) {
    courseBookmarked(course.value);
  }

  const action = course.value.bookmarked ? 'has been added to' : 'has been removed from';
  const message = `This ${course.value.type} ${action} your list of ${course.value.type}s.`;

  dispatchMessage('Success', 'success', message);
};

const bookmarkTip = computed(() => {
  if (!course.value) {
    return '';
  }

  const action = course.value.bookmarked ? 'Remove from' : 'Add to';
  const courseType = course.value.type + 's';
  return `${action} your ${courseType}`;
});

</script>

<template>
  <div
    class="bookmark-button"
    :class="{'bookmarked': course?.bookmarked, 'not-bookmarked': !course?.bookmarked}"
  >
    <MTooltip :tip="bookmarkTip">
      <MButtonCta
        :type="'secondary'"
        icon-left="bookmark"
        @click="toggleBookmarkCourse"
      />
      <span class="action-icon">
        {{course?.bookmarked ? '–' : '+'}}
      </span>
    </MTooltip>
  </div>
</template>

<style lang="scss">
.bookmark-button {
  position: relative;

  &.bookmarked {
    .m-button {
      background-color: var(--palette-neutral-80);
      border-color: var(--palette-neutral-80);
      color: var(--palette-neutral-10);

      &:hover {
        background-color: var(--palette-neutral-10);
        border-color: var(--palette-neutral-80);
        color: var(--palette-neutral-80);
      }
    }
  }

  .action-icon {
    font-family: 'monospace';
    display: block;
    position: absolute;
    top: 2%;
    left: 50%;
    width: 1rem;
    opacity: 0;
    transform: translateX(.5em);
    text-shadow: rgb(255, 255, 255) 2px 0px 0px,
      rgb(255, 255, 255) 1.75517px 0.958851px 0px,
      rgb(255, 255, 255) 1.0806px 1.68294px 0px,
      rgb(255, 255, 255) 0.141474px 1.99499px 0px,
      rgb(255, 255, 255) -0.832294px 1.81859px 0px,
      rgb(255, 255, 255) -1.60229px 1.19694px 0px,
      rgb(255, 255, 255) -1.97998px 0.28224px 0px,
      rgb(255, 255, 255) -1.87291px -0.701566px 0px,
      rgb(255, 255, 255) -1.30729px -1.5136px 0px,
      rgb(255, 255, 255) -0.421592px -1.95506px 0px,
      rgb(255, 255, 255) 0.567324px -1.91785px 0px,
      rgb(255, 255, 255) 1.41734px -1.41108px 0px,
      rgb(255, 255, 255) 1.92034px -0.558831px 0px;
    font-size: 2em;
    transition: all .25s ease-out;
    pointer-events: none;
    text-align: center;
  }

  .m-button:hover + .action-icon {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>

